export default __webpack_public_path__ + "static/media/google_pay.08617569.svg";